var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderclick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 1024 1024",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eeebcc",
    d: "M95.9372+817.997L95.9372+293.997L925.605+293.997L925.605+817.997C925.605+866.031+886.305+905.331+838.272+905.331L183.271+905.331C135.237+905.331+95.9372+866.031+95.9372+817.997Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.541+216.373L926.541+344.268L96.8736+344.268L96.8736+216.373C96.8736+169.479+136.174+131.11+184.207+131.11L839.208+131.11C887.241+131.11+926.541+169.479+926.541+216.373Z",
    opacity: 1,
    fill: "#33a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M926.782+310.922C926.782+316.758+924.674+388.06+910.506+458.505C891.73+551.862+812.966+821.445+717.489+854.195C700.502+860.022+664.113+863.742+616.141+865.31C583.712+866.369+322.156+867.533+223.844+867.533C170.575+867.533+98.8484+868.318+59.2959+863.642C56.712+863.272+44.9102+861.671+35.9517+855.306C26.4634+848.565+23.3824+842.456+21.8405+835.992C19.1808+824.841+21.2139+816.887+23.0227+806.911C25.0764+795.583+44.6164+742.066+52.4635+715.259C59.4676+691.331+78.3797+628.527+85.9661+555.139C95.3502+464.36+99.5113+316.208+99.701+308.798C375.467+308.798+651.016+310.737+926.782+310.922Z",
    fill: "#fffde8",
    strokeWidth: 1,
    strokeLinejoin: "round",
    stroke: "#fffde8",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0212+308.223L926.689+308.223L926.689+344.035L97.0212+344.035L97.0212+308.223Z",
    opacity: 1,
    fill: "#288aec"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#cd4238",
    d: "M1231.83+953.208L1236.09+953.208C1237.27+953.208+1238.22+954.161+1238.22+955.338L1238.22+955.338C1238.22+956.515+1237.27+957.469+1236.09+957.469L1231.83+957.469C1230.65+957.469+1229.7+956.515+1229.7+955.338L1229.7+955.338C1229.7+954.161+1230.65+953.208+1231.83+953.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    opacity: 1,
    fill: "#ff5346",
    strokeWidth: 1,
    stroke: "#ff5346",
    strokeLinejoin: "round",
    d: "M660.585+760.469C654.501+766.923+643.175+770.407+634.647+771.338C616.811+773.284+575.518+773.3+544.974+772.262C538.147+772.03+528.176+765.775+536.054+750.6C543.587+736.087+564.082+682.345+573.094+657.848C577.314+646.376+578.203+639.962+593.683+637.761C629.932+637.461+663.683+637.938+699.932+638.065C704.308+638.08+709.88+644.776+706.838+654.648C699.638+678.018+678.583+741.379+660.585+760.469Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.167+757.788C476.457+772.391+465.371+772.262+456.802+772.677C439.1+773.534+400.031+773.188+369.487+772.15C362.66+771.918+352.402+766.426+358.741+750.546C365.54+733.515+384.469+682.552+393.48+658.055C397.7+646.583+398.59+640.169+414.07+637.968C450.319+637.668+484.069+638.145+520.319+638.272C524.694+638.288+530.409+645.028+527.225+654.855C517.447+685.03+498.533+735.381+485.167+757.788Z",
    strokeWidth: 1,
    fill: "#d5d3bb",
    strokeLinecap: "round",
    stroke: "#d5d3bb",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    stroke: "#d5d3bb",
    fill: "#d5d3bb",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: "M311.309+752.363C302.223+768.684+287.915+771.487+279.339+771.713C260.158+772.218+225.548+772.34+193.714+771.69C178.761+771.385+177.322+761.082+181.412+750.048C191.573+722.639+205.441+681.793+214.452+657.297C218.672+645.825+219.562+639.41+235.042+637.209C271.291+636.909+305.041+637.386+341.291+637.514C345.666+637.529+351.239+644.224+348.197+654.096C340.996+677.466+319.958+736.826+311.309+752.363Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    stroke: "#d5d3bb",
    opacity: 1,
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: "M757.737+475.583C754.771+491.484+748.342+526.879+733.552+575.118C727.522+594.784+726.239+595.488+702.238+595.392C664.09+595.24+640.846+595.116+609.126+594.993C600.935+594.962+595.787+587.062+598.227+577.269C604.401+552.496+618.625+495.925+623.588+474.655C626.087+463.946+637.202+461.514+645.136+461.419C682.894+460.969+709.114+460.435+746.49+461.395C756.723+461.658+759.991+463.506+757.737+475.583Z",
    fill: "#d5d3bb"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    strokeLinecap: "round",
    fill: "#d5d3bb",
    strokeLinejoin: "round",
    stroke: "#d5d3bb",
    strokeWidth: 1,
    d: "M574.266+474.831C571.3+490.732+564.871+526.127+550.081+574.366C544.051+594.033+542.768+594.736+518.767+594.64C480.619+594.488+457.375+594.364+425.655+594.242C417.464+594.21+412.316+586.31+414.756+576.517C420.93+551.744+435.154+495.173+440.117+473.903C442.616+463.194+453.731+460.762+461.665+460.668C499.423+460.217+525.643+459.684+563.019+460.643C573.252+460.906+576.52+462.754+574.266+474.831Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d5d3bb",
    strokeWidth: 1,
    opacity: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "M388.177+475.387C378.199+527.494+381.908+510.536+367.991+574.921C363.645+595.028+360.678+595.291+336.677+595.196C298.529+595.043+275.285+594.92+243.565+594.797C235.374+594.765+230.226+586.866+232.667+577.073C238.84+552.3+249.065+495.729+254.027+474.459C256.526+463.75+275.575+461.223+275.575+461.223C275.575+461.223+337.701+461.087+376.93+461.199C387.166+461.228+390.487+463.32+388.177+475.387Z",
    fill: "#d5d3bb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderclick);
export default __webpack_public_path__ + "static/media/Calender click.d06b942d96ecccee4854142cdf24c641.svg";
export { ForwardRef as ReactComponent };